import Ajax from "base/Ajax";
import CookieHelper from "base/CookieHelper";
import Message from "base/Message";
import AjaxConfirmModal from "modals/AjaxConfirmModal";
import AjaxForm, { EVENT_SUCCESS } from "webPage/AjaxForm";
import Page from "webPage/Page";

Page.register(new RegExp('^/customers/([0-9a-f]+)/projects/([0-9a-f]+)/?$'), ([customer_id, project_id]) => {
    let form = new AjaxForm($(".container"), ($form, formData) => {
        return Ajax.post("billing", "projects/" + (project_id === "add" ? "" : project_id), $.extend({customer: customer_id}, formData));
    });

    form.on(EVENT_SUCCESS, (data) => {
        if (project_id === "add") {
            CookieHelper.set('did-add-project', data.id);
            window.location.href = data.links.view;

            // Keep loading
            return false;
        }

        form.getErrorContainer().html(Message.get_inline_message('The project has been updated successfully', 'Project updated', Message.SUCCESS));
    });

    handleOverridenAddress(form.getFormElement());

    $("body").on("click", ".js-delete-project", () => {
        let modal = new AjaxConfirmModal("Are you sure you want to remove this project", undefined, async () => {
            await Ajax.delete("billing", "projects/" + project_id);

        });
        modal.on("success", async () => {
            CookieHelper.set('did-delete-project', customer_id);
            window.location = "/customers/" + customer_id + "/";
        });
        modal.show();

        return false;
    });
});

export function handleOverridenAddress($element) {
    $element.on("change", ".js-override-address", function () {
        let $wrap = $(this).closest('.js-address-wrap');

        $wrap.find("input:not(:checkbox),select").prop("disabled", !$(this).is(":checked"));
    });
}
